import React, { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

interface SectionCountBadgeProps {
  count: number;
}

export const SectionCountBadge = ({ count }: SectionCountBadgeProps): ReactElement => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '24px',
      padding: '2px 10px',
      backgroundColor: '#F0F0F0',
      borderRadius: '12px',
    }}
  >
    <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#6B6B6B' }}>
      {count}
    </Typography>
  </Box>
);
